<template>
  <div id="more">
    <h2>More</h2>
    <div v-if="isAuthenticated">
      <p>
        If you need assistance, please reach out to us at <a href="tel:+18336926925">(833) NYC-OWAL</a> (833) 692-6925.
      </p>
      <p>
        To see and edit confirmed matches, <router-link to="/confirmed">
          click here
        </router-link>. Clean data helps ensure a reliable algorithm.
      </p>
      <p>
        Face not showing up? <a
          href="#/more"
          @click="forceRefresh"
        >Force refresh</a>.
      </p>
    </div>
    <div v-else>
      To start, please <router-link to="/login">
        log in
      </router-link>.
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'More',
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  methods: {
    ...mapActions(['loadFrontendFaces']),
    forceRefresh () {
      this.loadFrontendFaces()
    },
  },
}
</script>

<style scoped>
#header {
  background-color: #4c4;
}

a:hover {
  text-decoration: underline;
}
</style>
